// Whether the feedback dialog is open: the top bar's Feedback button and the
// `F` shortcut open it; App.svelte holds the one dialog.

class FeedbackUi {
  open = $state(false);

  show(): void {
    this.open = true;
  }
}

export const feedbackUi = new FeedbackUi();
